const DELETETABLE_ROWS_AFTER = 7;
const SPECIAL_HEADERS_COUNT = 1;

export {
  DELETETABLE_ROWS_AFTER,
  SPECIAL_HEADERS_COUNT,
}